import React from "react";
import ReactDOM from "react-dom";
import "./assets/main.css";
import App from "./components/App";

import * as serviceWorker from "./serviceWorker";

// const firebaseConfig = {
//   apiKey: "AIzaSyDI11Hfdwj1WgdxhaspeAfO_Uoskue4JtI",
//   authDomain: "manik-satimata-store.firebaseapp.com",
//   databaseURL: "https://manik-satimata-store.firebaseio.com",
//   projectId: "manik-satimata-store",
//   storageBucket: "manik-satimata-store.appspot.com",
//   messagingSenderId: "186692434084",
//   appId: "1:186692434084:web:e593e8b0d5976e65a70e31",
//   measurementId: "G-FJ3FFTYGKS",
// };
// firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
